import { useEffect, useState } from 'react';

import { Checkbox, Input, InputNumber, Select } from 'antd';
import { ModalForm, SelectSearch } from 'components';
import type { FieldData } from 'components/modal-form';
import { type UserPermissionType, UserPermissionTypeList } from 'models/user';
import { trackersApi } from 'services/rtk/trackers';
import { usersApi } from 'services/rtk/users';

interface TrackerNames {
  id: number;
  name: string;
}

interface Props {
  userId: number;
  isModalVisible: boolean;
  setIsModalVisible: (state: boolean) => void;
}

export const AddPermissionModal = ({ isModalVisible, setIsModalVisible, userId }: Props) => {
  const [permissionType, setPermissionType] = useState<UserPermissionType>('KEITARO_CREDS');
  const [trackers, setTrackers] = useState<TrackerNames[]>([]);
  const [searchCategory, setSearchCategory] = useState('');
  const [selectedTracker, setSelectedTracker] = useState<number>(0);

  const { data } = trackersApi.useFetchAllTrackersQuery({});

  useEffect(() => {
    const trackerNames: TrackerNames[] = data?.data.map((el) => ({ id: el.id, name: el.name })) ?? [];
    setTrackers(trackerNames);
  }, [data]);

  const fields: FieldData[] = [
    {
      label: 'Тип записи',
      name: 'typeName',
      render: (
        <Select
          id="me-add-keitaro-modal-note-type-select"
          value={permissionType}
          onChange={setPermissionType}
        >
          {UserPermissionTypeList.map((type) => {
            const label = () => {
              switch (type) {
                case 'KEITARO_CREDS':
                  return 'Keitaro токен';
                case 'LIMIT_ACCOUNTS':
                  return 'Лимит аккаунтов';
              }
            };
            return <Select.Option key={type}>{label()}</Select.Option>;
          })}
        </Select>
      ),
      noSend: true,
    },
    {
      label: 'Лимит аккаунтов',
      name: 'limitAccountPurchase',
      noRender: permissionType !== 'LIMIT_ACCOUNTS',
      render: <InputNumber id="me-add-keitaro-modal-accounts-counter-input" />,
    },
    {
      label: 'Домен keitaro:',
      name: 'trackerId',
      noRender: permissionType !== 'KEITARO_CREDS',
      render: (
        <SelectSearch
          id="me-add-keitaro-modal-search-by-tracker"
          data={trackers}
          value={selectedTracker}
          onChange={setSelectedTracker}
          className="wide"
          placeholder="Поиск по трекеру"
          searchValue={searchCategory}
          onSearch={setSearchCategory}
          allowClear={true}
        />
      ),
    },
    {
      label: 'Token:',
      name: 'token',
      noRender: permissionType !== 'KEITARO_CREDS',
      render: <Input.Password id="me-add-keitaro-modal-token-input" placeholder="Введите токен" />,
    },
    {
      label: 'Разрешена загрузка:',
      name: ['permissions', 'canUpload'],
      noRender: permissionType !== 'KEITARO_CREDS',
      valuePropName: 'checked',
      required: false,
      render: <Checkbox id="me-add-keitaro-modal-allow-download-checkbox" />,
    },
    { label: 'id', name: 'id', hidden: true, render: <Input type="hidden" /> },
  ];

  if (!isModalVisible) return null;

  return (
    <ModalForm
      title="Добавить запись"
      successMessage="Запись добавлена"
      isModalVisible={isModalVisible}
      setIsModalVisible={setIsModalVisible}
      mutation={
        permissionType === 'KEITARO_CREDS'
          ? usersApi.useAddUserTrackersMutation
          : usersApi.useUpdateUserPermissionsMutation
      }
      fields={fields}
      fieldsToSet={{
        id: userId,
        permissions: permissionType === 'KEITARO_CREDS' ? { canUpload: false } : undefined,
      }}
      isTracker
    />
  );
};
